import { render, staticRenderFns } from "./intelinvest.vue?vue&type=template&id=4b6fdbcf&scoped=true"
import script from "./intelinvest.vue?vue&type=script&lang=js"
export * from "./intelinvest.vue?vue&type=script&lang=js"
import style0 from "./intelinvest.vue?vue&type=style&index=0&id=4b6fdbcf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6fdbcf",
  null
  
)

export default component.exports